export const name = "ATAN";
export const summary = `Computes the inverse tangent of \`X\`.`;
export const reference = `
## ATAN

Computes the inverse tangent of \`X\`.

\`\`\`
ATAN(X)
\`\`\`

### Description

Computes the principal value of the inverse tangent of X. The return value is in the range [-π/2,π/2]. Doesn't fail.

| X | ATAN(X) |
| --- | --- |
| \`+inf\` | π/2 |
| \`-inf\` | -π/2 |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
